export default "__VITE_ASSET__C48K59nU__"